;(function () {
  'use strict'

  angular
    .module('contrast.settings.user.tsv')
    .controller('ModalTsvBackupCodesCtrl', ModalTsvBackupCodesCtrl)

  function ModalTsvBackupCodesCtrl(
    $uibModalInstance,
    $timeout,
    tsvCodesDownloader,
    title,
    codes
  ) {
    'ngInject'

    var vm = this

    angular.extend(vm, {
      title: title,
      codes: codes,
      state: 'waitForUser'
    })

    angular.extend(vm, {
      download: download,
      ok: ok,
      cancel: cancel
    })

    function download() {
      vm.state = 'downloading'
      tsvCodesDownloader.download(codes)
      $timeout(function () {
        vm.state = 'downloaded'
      }, 500)
    }

    function ok() {
      $uibModalInstance.dismiss('ok')
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }
  }
})()
